/* eslint-disable
    func-names,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Store', '_'];
const factory = function (Store, _) {
  // A helper class to create Stores that won't allow updated data
  // to be overridden.
  let ViewModel;
  return (ViewModel = class ViewModel extends Store {
    // binds this view model to a store
    $setModel(store) {
      if (this.$model) {
        this.$unListen(this.$model);
      }
      this.$model = store;
      this.$listen(store);
      return this;
    }

    $reset(fields) {
      let data;
      if (fields) {
        data = _.pick(this.$model.$data(), fields);
      } else {
        data = this.$model.$data();
      }

      return this.$set(data);
    }

    // prints out the newer object in a XOR-like fashion
    $$findDirty(updated, original) {
      // iterate over fields in updated object
      return _(updated)
        .omitBy(
          (
            value,
            key, // omit non-different keys
          ) => _.isEqual(updated[key], original[key]),
        )
        .mapValues((value, key) => {
          // return diff values
          const oldValue = original[key];
          if (_.isPlainObject(value) && _.isPlainObject(oldValue)) {
            return this.$$findDirty(value, oldValue);
          }
          return value;
        })
        .value();
    }

    $listenTransformFn(newData, oldData, lastUpdated) {
      // compare oldData with data in ViewModel to see what's dirty
      const diff = this.$$findDirty(this.$data(), oldData);
      return _.merge({}, newData, diff);
    }
  });
};

factory.$inject = deps;
module.exports = factory;
